"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _Filter = _interopRequireDefault(require("@micado-digital/react-filter/Filter"));
var _ConditionalWrapper = _interopRequireDefault(require("@micado-digital/react-ui/components/ConditionalWrapper"));
var _useFetch = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useFetch"));
var _useFilter = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useFilter"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _parseStringToArray2 = _interopRequireDefault(require("../../utils/parseStringToArray"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _it = _interopRequireDefault(require("../../locals/it.json"));
var _ProductOverview = _interopRequireDefault(require("./ProductOverview01.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Buttons = (0, _component.default)(() => import("./Buttons"));
const Counter = (0, _component.default)(() => import("./Counter"));
const Drawer = (0, _component.default)(() => import("@material-ui/core/Drawer"));
const DrawerToolbar = (0, _component.default)(() => import("../../components/DrawerToolbar"));
const FilterButton = (0, _component.default)(() => import("./Filter/FilterButton"));
const FilterConnector = (0, _component.default)(() => import("./Filter/FilterConnector"));
const Groups = (0, _component.default)(() => import("./Groups"));
const List = (0, _component.default)(() => import("./List"));
const Preloader = (0, _component.default)(() => import("../../components/Preloader"));
const SelectedFilter = (0, _component.default)(() => import("./SelectedFilter"));
const Search = (0, _component.default)(() => import("./Search"));
const Sort = (0, _component.default)(() => import("./Sort"));
const ProductOverview01 = _ref => {
  let {
    defaultLang = "de",
    displayedFeatures = [],
    excludedFilter = ["groups"],
    filterListURL = "",
    listURL = "",
    page = 1,
    pageSize = 12,
    preSelectedValues = {},
    productTeaserComponent,
    selectedFilter = [],
    selectedGroup = "",
    showAttributes = true,
    showBack = true,
    showBookmark = true,
    showCategories = true,
    showFilter = true,
    sort = 7
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang: pageDataLang
  } = pageData || {};
  const [categoriesOpen, setCategoriesOpen] = (0, _react.useState)(false);
  const [filterOpen, setFilterOpen] = (0, _react.useState)(false);
  const [localValues, setLocalValues] = (0, _react.useState)({});
  const [lang, setLang] = (0, _react.useState)(defaultLang);
  const refForm = (0, _react.useRef)(null);
  const refList = (0, _react.useRef)(null);
  const filter = (0, _useFilter.default)(refForm, {
    groups: selectedGroup !== null && selectedGroup !== void 0 ? selectedGroup : "",
    lang,
    page,
    pageSize,
    sort,
    ...preSelectedValues
  }, [{
    page: 1
  }]);
  const _filterListURL = filterListURL ? filterListURL : "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.ProductApi/FilterList.api");
  const _listURL = listURL ? listURL : "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.ProductApi/List.api");
  const products = (0, _useFetch.default)({
    data: {
      ...filter,
      action: "filter"
    },
    url: _listURL,
    method: "GET"
  }, [filter], !(0, _isEmpty.default)(filter));
  const {
    entries = 0,
    items = [],
    _loading
  } = products || {};
  const theme = (0, _useTheme.default)();
  const isMobile = (0, _useMediaQuery.default)(theme.breakpoints.down("sm"));
  const css = (0, _ProductOverview.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(() => {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  (0, _react.useEffect)(() => {
    var _filter$groups, _filter$lang, _filter$price;
    setFilterOpen(false);
    let _localValues = {};
    for (const key in filter) {
      var _parseStringToArray;
      _localValues[key] = (_parseStringToArray = (0, _parseStringToArray2.default)(filter[key])) !== null && _parseStringToArray !== void 0 ? _parseStringToArray : [];
    }
    _localValues.groups = (_filter$groups = filter.groups) !== null && _filter$groups !== void 0 ? _filter$groups : selectedGroup;
    _localValues.lang = (_filter$lang = filter.lang) !== null && _filter$lang !== void 0 ? _filter$lang : lang;
    _localValues.page = filter.page ? parseInt(filter.page) : page;
    _localValues.pageSize = filter.pageSize ? parseInt(filter.pageSize) : pageSize;
    _localValues.price = (_filter$price = filter === null || filter === void 0 ? void 0 : filter.price) !== null && _filter$price !== void 0 ? _filter$price : "";
    _localValues.sort = filter.sort ? parseInt(filter.sort) : sort;
    setLocalValues(_localValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);
  const handleClearFilter = () => {
    setLocalValues({
      groups: selectedGroup !== null && selectedGroup !== void 0 ? selectedGroup : "",
      lang,
      page,
      pageSize,
      price: "",
      sort
    });
    handleSubmit(100);
  };
  const handleGroupClick = function () {
    let groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    setLocalValues({
      groups,
      lang,
      page,
      pageSize,
      price: "",
      sort: groups ? 8 : sort
    });
    handleSubmit(100);
  };
  const handlePaginate = (e, page) => {
    setLocalValues(prevLocalValues => ({
      ...prevLocalValues,
      page
    }));
    handleSubmit(100);
  };
  const handleSubmit = function () {
    let delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    setTimeout(() => {
      submitForm();
    }, delay);
  };
  const submitForm = () => {
    if (!(refForm !== null && refForm !== void 0 && refForm.current)) return;
    const evt = new CustomEvent("submit", {
      bubbles: true,
      cancelable: true
    });
    refForm.current.dispatchEvent(evt);
  };
  return /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx.default)(css.productOverview, "mco-shop-product-overview"),
    maxWidth: "lg"
  }, showCategories && /*#__PURE__*/_react.default.createElement(_ConditionalWrapper.default, {
    condition: isMobile,
    wrapper: children => /*#__PURE__*/_react.default.createElement(Drawer, {
      anchor: "left",
      classes: {
        paper: (0, _clsx.default)(css.paper, "mco-shop-paper")
      },
      open: categoriesOpen,
      variant: "persistent",
      onClose: setCategoriesOpen
    }, children)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.column, "mco-shop-product-overview__column")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.groups, "mco-shop-product-overview__groups")
  }, isMobile && /*#__PURE__*/_react.default.createElement(DrawerToolbar, {
    setOpen: setCategoriesOpen,
    title: /*#__PURE__*/_react.default.createElement(_Local.default, {
      identifier: "reactShop.productOverview.titles.categories",
      l: l
    })
  }), /*#__PURE__*/_react.default.createElement(Groups, {
    lang: lang,
    localValues: localValues,
    setLocalValues: setLocalValues,
    setOpen: setCategoriesOpen,
    showBack: showBack,
    onSubmit: handleGroupClick
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.search, "mco-shop-product-overview__search")
  }, /*#__PURE__*/_react.default.createElement(Search, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.contentColumn, "mco-shop-product-overview__content", {
      [css.hasLeftColumn]: showCategories
    })
  }, (isMobile && !showFilter || showFilter) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.wrapper, "mco-shop-product-overview__wrapper")
  }, (isMobile && !showFilter || showFilter) && /*#__PURE__*/_react.default.createElement(Counter, {
    itemsCounter: entries,
    lang: lang,
    loading: _loading
  }), isMobile && /*#__PURE__*/_react.default.createElement(Buttons, {
    lang: lang,
    setCategoriesOpen: setCategoriesOpen,
    setFilterOpen: setFilterOpen,
    showCategories: showCategories
  })), /*#__PURE__*/_react.default.createElement(_Filter.default, {
    api: _filterListURL,
    excludedFilter: excludedFilter,
    lang: lang,
    localValues: localValues,
    preSelectedValues: preSelectedValues,
    refForm: refForm,
    selectedFilter: selectedFilter,
    setLocalValues: setLocalValues
  }, /*#__PURE__*/_react.default.createElement(_ConditionalWrapper.default, {
    condition: isMobile,
    wrapper: children => /*#__PURE__*/_react.default.createElement(Drawer, {
      anchor: "left",
      classes: {
        paper: (0, _clsx.default)(css.paper, "mco-shop-paper")
      },
      open: filterOpen,
      variant: "persistent",
      onClose: setFilterOpen
    }, children)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.filter, "mco-shop-product-overview__filter")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.filterWrapper, "mco-shop-product-overview__filter-wrapper", {
      [css.filterWrapperHasFilter]: showFilter,
      "mco-shop-product-overview__filter-wrapper--has-filter": showFilter
    })
  }, !isMobile && !showFilter && /*#__PURE__*/_react.default.createElement(Counter, {
    itemsCounter: entries,
    lang: lang,
    loading: _loading
  }), /*#__PURE__*/_react.default.createElement(FilterConnector, {
    lang: lang,
    maxVisibleOptions: 6,
    setFilterOpen: setFilterOpen,
    showFilter: showFilter,
    onSubmit: handleSubmit
  }), !isMobile && /*#__PURE__*/_react.default.createElement(Sort, {
    lang: lang,
    onSubmit: handleSubmit
  })), isMobile && /*#__PURE__*/_react.default.createElement(FilterButton, {
    lang: lang
  }))), /*#__PURE__*/_react.default.createElement(SelectedFilter, {
    lang: lang,
    onClearFilter: handleClearFilter,
    onSubmit: handleSubmit
  })), _loading ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.preloader, "mco-shop-product-overview__preloader")
  }, /*#__PURE__*/_react.default.createElement(Preloader, null)) : /*#__PURE__*/_react.default.createElement(List, {
    currentPage: localValues.page,
    displayedFeatures: displayedFeatures,
    items: items,
    itemsCounter: entries,
    itemsPerPage: pageSize,
    lang: lang,
    loading: _loading,
    productTeaserComponent: productTeaserComponent,
    ref: refList,
    showAttributes: showAttributes,
    showBookmark: showBookmark,
    showCategories: showCategories,
    showFilter: showFilter,
    onPaginate: handlePaginate
  })));
};
ProductOverview01.propTypes = {
  defaultLang: _propTypes.default.string,
  displayedFeatures: _propTypes.default.array,
  excludedFilter: _propTypes.default.array,
  filterListURL: _propTypes.default.string,
  listURL: _propTypes.default.string,
  page: _propTypes.default.number,
  pageSize: _propTypes.default.number,
  preSelectedValues: _propTypes.default.object,
  productTeaserComponent: _propTypes.default.object,
  selectedFilter: _propTypes.default.array,
  selectedGroup: _propTypes.default.string,
  showAttributes: _propTypes.default.bool,
  showBack: _propTypes.default.bool,
  showBookmark: _propTypes.default.bool,
  showCategories: _propTypes.default.bool,
  showFilter: _propTypes.default.bool,
  sort: _propTypes.default.number
};
var _default = exports.default = ProductOverview01;